import { Provider } from "mobx-react";
import React from "react";
import { IntlProvider } from "react-intl";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import SnackProvider from "./providers/SnackProvider";
import { routeConfig } from "./routes/Routes";
import rootStore from "./stores/rootStore";
import { store } from "./new-store/store";
import { Provider as ReduxProvider } from "react-redux";
const router = createBrowserRouter(routeConfig);

const App = () => {
  return (
    <React.StrictMode>
      <IntlProvider locale={"en"}>
        <Provider store={rootStore}>
          <ReduxProvider store={store}>
            <SnackProvider>
              <main className="antialiased">
                <RouterProvider router={router} />
              </main>
            </SnackProvider>
          </ReduxProvider>
        </Provider>
      </IntlProvider>
    </React.StrictMode>
  );
};

export default App;
